import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Seo from "@/components/Seo";

export default function Redirect301({ to }) {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(to, { replace: true });
  }, [to, navigate]);

  return (
    <div className="mx-auto max-w-3xl px-6 py-24">
      <Seo title="Page déplacée — Decennale Artisans" description="Cette page a été déplacée vers une adresse plus récente." path={to} noindex />
      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-ink/60 mb-4">Redirection</p>
      <h1 className="font-display text-3xl font-extrabold uppercase tracking-tighter mb-4">
        Cette page a été déplacée.
      </h1>
      <p className="text-base text-ink/75">
        Vous allez être redirigé automatiquement. Sinon,{" "}
        <a href={to} className="underline underline-offset-4 text-accent">
          cliquez ici pour accéder à la nouvelle page
        </a>
        .
      </p>
    </div>
  );
}
